<script>
import ProInput from '$common/ProInput'
export default {
  name: 'Login',
  props: {
    options: {
      required: true,
    },
  },
  components: {
    'pro-input': ProInput,
  },
  data () {
    return {
      form: {
        email: '',
        password: '',
      },
      formOptions: {
        email: {
          title: 'Email',
          type: 'email',
        },
        password: {
          title: 'Password',
          type: 'password',
        },
      },

      loading: false,
    }
  },
  computed: {
    message () {
      return this.options.message
    },
  },
  methods: {
    async login () {
      this.loading = true
      try {
        await this.$auth.signInWithEmailAndPassword(this.form.email, this.form.password)
        this.$modals.hide('login')
      } catch (e) {
        console.error(e)
        this.loading = false
        this.$toast(e.message)
      }
    },
    onSignUp () {
      this.$modals.hide('login')
      if (this.$route.name === 'ApplyMain') return
      this.$router.push({name: 'ApplyMain'})
    },
    resetPassword () {
      this.$modals.show({name: "password-reset", email: this.form.email})
      this.$modals.hide('login')
    }
  },
}
</script>

<template lang="pug">
  #login-main.modal-main
    .login-container.modal-container
      .title Login
      .message(
        v-if='message'
      ) {{message}}
      .content
        .pro-form
          .form-row(
            v-for='(options, key) in formOptions'
            @keyup.enter='key === "password" && !loading && login()'
          )
            pro-input(
              :options='options'
              v-model='form[key]'
            )
        .action-link
          .reset-password(
            @click='resetPassword()'
          ) Forgot your password?
      .action
        .two-buttons
          .button.cancel(
            @click=`$modals.hide('login')`
          ) Cancel
          .button(
            @click='!loading && login()'
          ) {{loading ? 'Logging in..' : 'Login'}}
        .one-button
          .button.sign-up(
            @click='onSignUp'
          ) Sign Up
        
</template>

<style lang="sass" scoped>
  @import '$styles/form'
  #login-main
    max-width: 300px
    .login-container
      .message
        font-weight: bold
        background-color: orange
      .content
        padding-top: 30px
      .action
        .two-buttons
          display: grid
          grid-template-columns: minmax(15%, 150px) minmax(15%, 150px)
          margin-bottom: 1rem
        .one-button
          display: grid
          .sign-up
            background: white
            color: red
      .action-link
        color: blue
        text-decoration: underline
        text-align: center
        font-size: 0.8rem
        .reset-password
          cursor: pointer
</style>